import { BUTTON_SIZES } from 'ui/button';
import { CircleSpinner } from 'ui/spinner';
import { Tooltip } from 'ui/tooltip';
import { useTranslation } from '../../hooks';
import { usePermissionsContext } from '../../contexts/permissions';
import { StyledUpdateButton } from './Styled';
import { useSegmentationQueryContext } from '../../contexts/segmentationQuery';
import { useListReferencesContext } from '../../contexts/listReferences';
import { FORM_ID } from '../../constants';
import { SubmitType } from '../../types';
import { FETCH_REFERENCES_TRIGGER } from '../segmentationResults/referencesInsights/constants';
import { useIsCatalogSaveRestricted } from '../../hooks/useIsCatalogSaveRestricted';

export const testIds = {
  buttonUpdate: 'segmentation-ub-btn-update',
};

// Available in the SidePanel when a dynamic list is selected (pageVariation === PAGE_VARIATIONS.DYNAMIC)

export const UpdateButton = () => {
  const { t } = useTranslation();
  const { isLoading: isLoadingListReferences, fetchTrigger } = useListReferencesContext();
  const shouldShowLoadingReferencesSpinner =
    fetchTrigger === FETCH_REFERENCES_TRIGGER.MODAL && isLoadingListReferences;

  const { canManageSegmentation } = usePermissionsContext();
  const { isValidQuery } = useSegmentationQueryContext();
  const catalogQueryTooltip = t('actionMenu.disabledByCatalogQuery');
  const tooltip = !canManageSegmentation
    ? t(`permissions.manageSegmentation`)
    : t('actionMenu.disabled');

  const isCatalogSaveRestricted = useIsCatalogSaveRestricted();

  const isButtonDisabled =
    !canManageSegmentation || !isValidQuery || isCatalogSaveRestricted || isLoadingListReferences;

  return (
    <Tooltip
      isEnabled={!canManageSegmentation || !isValidQuery || isCatalogSaveRestricted}
      tooltipContent={isCatalogSaveRestricted ? catalogQueryTooltip : tooltip}
    >
      <StyledUpdateButton
        data-test={testIds.buttonUpdate}
        isDisabled={isButtonDisabled}
        type={'submit'}
        form={FORM_ID}
        id={SubmitType.update}
        size={BUTTON_SIZES.SMALL}
      >
        {shouldShowLoadingReferencesSpinner ? (
          <CircleSpinner size={20} />
        ) : (
          <span>{t('actionMenu.update.label')}</span>
        )}
      </StyledUpdateButton>
    </Tooltip>
  );
};
